module.exports = __webpack_public_path__ + "static/media/powered-by-open-network.b5a82d05.png";